

import React, { useState } from 'react';
import axios from 'axios';
import './homefooter.css';
import { faFacebook, faInstagram, faYoutube, faMailchimp } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';
import API from '../api';
import { Link } from 'react-router-dom';
const HomeFooter = () => {
  // FIX: Added 'description' to the initial state to match the textarea field
  const [formData, setFormData] = useState({ name: "", email: "", phone: "", description: "" });
  const [submitted, setSubmitted] = useState(false);
  // NEW: State to hold the phone number validation error message
  const [phoneError, setPhoneError] = useState("");

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // NEW: Add real-time validation for the phone number field
    if (name === "phone") {
      // Allow only digits by removing any non-digit characters
      const numericValue = value.replace(/[^0-9]/g, "");
      // Only update state if the length is 10 or less
      if (numericValue.length <= 10) {
        setFormData({ ...formData, [name]: numericValue });
        // Clear error if user is correcting the input
        if (phoneError) {
          setPhoneError("");
        }
      }
    } else {
      // Handle other input fields normally
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // NEW: Final validation before submitting the form
    if (formData.phone.length !== 10) {
      setPhoneError("Phone number must be exactly 10 digits.");
      return; // Stop the function if validation fails
    }
    
    // Clear any previous error messages if validation passes
    setPhoneError("");

    try {
      await API.post("/contact", formData);
      setFormData({ name: "", email: "", phone: "", description: "" }); // Clear form fields
      setSubmitted(true);
      // Optional: Hide success message after a few seconds
      setTimeout(() => setSubmitted(false), 5000);
    } catch (error) {
      console.error("Error Submitting:", error);
      alert("Failed to Submit. Try again.");
    }
  };

  return (
    <footer className="footer-container" id='contact-section'>
      
    <div className='footer-content'>
      <div className="footer-links">
        <h2 style={{color:'white'}}>Quick links</h2>
        <div className="footer-column">
          <Link to="/About">About Us</Link>
          <Link to="/Classes">Classes</Link>
          <Link to="/blogs">Blogs</Link>
          <Link to="/product">Products</Link>
        </div>
      </div>

      <div className="newsletter-section">
        <h4>Contact Us</h4>
        <form onSubmit={handleSubmit} className="newsletter-form" noValidate> {/* Added noValidate to prevent default browser validation */}
          <input
            type="text"
            name="name"
            placeholder="Enter Your Name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />
          <input
            type="tel" // Use "tel" for phone numbers for better semantics
            name="phone"
            placeholder="Phone Number"
            value={formData.phone}
            onChange={handleInputChange}
            required
          />
          {/* NEW: Display the validation error message here */}
          {phoneError && <p className="error-message">{phoneError}</p>}
          
          <input
            type="email"
            name="email"
            placeholder="Enter your E-mail"
            value={formData.email}
            onChange={handleInputChange}
            required
          />
          <textarea
            name="description"
            placeholder="We'd love to hear from you!"
            value={formData.description}
            onChange={handleInputChange}
            required
            rows={3}
          />
          <button type="submit">Submit</button>
        </form>
        {submitted && <p className="success-message">Submitted successfully!</p>}
      </div>
    </div>
      <div className="social-icons">
        <a href="mailto:team.satvicpath@gmail.com" aria-label="email" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faEnvelope} size="lg"/>
        </a>
        <a href="https://www.instagram.com/satvic_path?igsh=MXE1ZmdibDI2d2k5OQ==" aria-label="Instagram" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faInstagram} size="lg" style={{ }} />
        </a>
        <a href="https://www.facebook.com/profile.php?id=61563612816400" aria-label="Facebook" target="_blank" rel="noopener noreferrer">
          <FontAwesomeIcon icon={faFacebook} size="lg" />
        </a>
      </div>

      <div className="footer-bottom">
        <a href="/t&c">Terms & Conditions</a> | <a href="/privacy">Privacy Policy</a>
        <p>© 2025 Satvic Path. All Rights Reserved.</p>
      </div>
    </footer>
  );
};

export default HomeFooter;